export default class FrameImageRepository
{
    /**
     * @param frameImagePreloader
     */
    constructor(frameImagePreloader) {
        this.frameImagePreloader = frameImagePreloader;
    }
    /**
     * @param callback
     */
    getAll(callback) {
        this.frameImagePreloader.loadFrameImages(() => {
            callback();
        });
    }
    /**
     * @returns {*}
     */
    getFrameImagePreloader() {
        return this.frameImagePreloader;
    }
}
